var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 rodape"},[_c('p',[_vm._v("Todos os direitos reservados @2023. Inove Sistemas.")])])
}]

export { render, staticRenderFns }